<template>
    <div v-click-outside="closeMenu">
        <div class="burger-menu" :class="{ 'burger-opened': !isClosed }">
            <button aria-label="Menu" @click="toggleShow">
                <span class="hamburger__btn mt-0"></span>
            </button>
        </div>

        <div v-show="!isClosed" class="hamburger--menu">
            <p class="space-route" v-for="(item, index) in filteredButtons" :key="index">
                <router-link
                    :to="{ name: item.route }"
                    v-on:click.native="toggleShow"
                    :class="{ 'selected-route': isActiveRoute(item) }"
                    class="my-account-route">
                    <span v-text="item.label"></span>
                </router-link>
            </p>
            <a
                v-if="isUserLoggedIn && !hasNoActiveSubscription"
                :href="countryUtils.zendesk_hc_url"
                class="my-account-route">
                {{ $t('TOP_NAVIGATION_HELP') }}
            </a>
        </div>
        <hamburger-menu
            :show="showHamburgerMenu"
            @closed="toggleShow">
        </hamburger-menu>

        <user-menu
            :show="showUserMenu"
            @menu-clicked="toggleShow"
            @closed="toggleShow">
        </user-menu>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import UserMenu from '@/components/structure/navigation/UserMenu';
import HamburgerMenu from '@/components/structure/navigation/Hamburger';
import { turnScrollOn, turnScrollOff } from '@/helpers/ScrollHelpers.js';
import countryUtils from '@/resources/countryUtils.json';

export default {
    name: 'HelpButton',
    data() {
        return {
            countryUtils: countryUtils.filter(item => item.locale.toLowerCase() === process.env.VUE_APP_DATE_LOCALE.toLowerCase())[0],
            showHamburger: false,
            isClosed: true,
            window: {
                width: 0,
                mobileBreakpoint: 768,
                tabletBreakpoint: 1024,
            },
        };
    },
    computed: {
        ...mapGetters({
            buttons: 'nav/getButtons',
            isUserLoggedIn: 'auth/isUserLoggedIn',
            hasUserFetched: 'account/getUserId',
            hasSubscriptionFetched: 'subscription/subscriptionsHaveFetched',
            hasActiveSubscription: 'subscription/hasActiveSubscription',
        }),
        hasNoActiveSubscription() {
            return this.hasUserFetched && this.hasSubscriptionFetched && !this.hasActiveSubscription;
        },
        filteredButtons() {
            const status = (this.isUserLoggedIn ? 'loggedIn' : 'loggedOut');
            return this.buttons.filter(button => this.hasNoActiveSubscription ? button[status] && button.label.toLowerCase() !== 'shop' : button[status] && button.route !== 'faq.categories');
        },
        isMobile() {
            return this.window.width <= this.window.mobileBreakpoint;
        },
        showHamburgerMenu() {
            return this.showHamburger && !this.isUserLoggedIn;
        },
        showUserMenu() {
            return this.showHamburger && this.isUserLoggedIn;
        },
    },
    mounted() {
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
    },
    methods: {
        toggleShow() {
            let isOrderSummaryOpened = this.$store.getters['shop/getOrderSummaryModalState'];
            isOrderSummaryOpened && this.$store.commit('shop/closeOrderSummary');
            this.isMobile
                ? this.showHamburger = !this.showHamburger
                : this.isClosed = !this.isClosed;
        },
        closeMenu() {
            this.isMobile
                ? this.showHamburger = false
                : this.isClosed = true;
        },
        handleResize() {
            this.window.width = window.innerWidth;
        },
        isActiveRoute(item) {
            return this.$route.name === item.route;
        },
    },
    components: {
        UserMenu,
        HamburgerMenu,
    },
    watch: {
        showHamburger: {
            handler(newValue) {
                return newValue ? turnScrollOff(document) : turnScrollOn(document);
            },
        },
    },
};
</script>

<style lang="scss" scoped>
.hamburger {
    &--menu {
        width: 260px;
        background-color: #ffffff;
        position: absolute;
        z-index: 9999;
        padding: 20px;
        left: 20px;
        text-align: left;
        box-shadow: 0px 8px 40px 0px #00000033;
    }
}

.burger-menu {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 48px;
    height: 48px;
    position: relative;
    background-color: #FFFFFF;
    border-radius: 50%;
    margin-left: -8px;
    transition: background-color .25s linear;
    -moz-transition: background-color .25s linear;
    -webkit-transition: background-color .25s linear;
}

.burger-menu:hover {
    transition: background-color .25s linear;
    -moz-transition: background-color .25s linear;
    -webkit-transition: background-color .25s linear;
    background-color: #ECE9E8;
}

.burger-opened {
    background-color: #ECE9E8;
}
</style>
